'use client'

import { LanguageProvider } from '@/lib/LanguageContext'
import { NavigationProvider } from '@/lib/NavigationContext'
import { ThemeProvider } from '@/lib/ThemeContext'

export function AppProviders({
    children,
    isRTL
}: {
    children: React.ReactNode
    isRTL: boolean
}) {
    return (
        <ThemeProvider>
            <div dir={isRTL ? 'rtl' : 'ltr'} className="min-h-screen">
                <LanguageProvider>
                    <NavigationProvider>
                        {children}
                    </NavigationProvider>
                </LanguageProvider>
            </div>
        </ThemeProvider>
    )
}
